<template>
  <div>
    <v-menu offset-y min-width="150" ccontent-class="elevation-1">
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          rounded
          depressed
          color="primary--dark"
          class="add_storage_item_button"
          v-bind="attrs"
          v-on="on"
          :disabled="isMenuDisabled"
        >
          {{ $t("academy_navigator.new") }}
        </v-btn>
      </template>
      <v-list class="pa-0">
        <v-list-item
          class="add-new-menu__item"
          height="30"
          @click="showAddFolderDialog"
        >
          <span class="add-new-menu__item-text"
            >{{ $t("common.folder")
            }}<v-icon color="secondary" size="20"
              >mdi-folder-open-outline</v-icon
            ></span
          >
        </v-list-item>
        <v-list-item
          class="add-new-menu__item"
          height="30"
          @click="showTodoDialog"
        >
          <span class="add-new-menu__item-text"
            >{{ $t("common.todo_list")
            }}<v-icon color="secondary" size="20">mdi-check</v-icon></span
          >
        </v-list-item>
        <v-list-item
          class="add-new-menu__item"
          height="20"
          @click="showFormDialog"
        >
          <span class="add-new-menu__item-text"
            >{{ $t("common.form")
            }}<v-icon color="secondary" size="20"
              >mdi-file-document-outline</v-icon
            ></span
          >
        </v-list-item>
        <v-list-item
          class="add-new-menu__item"
          height="20"
          @click="showStorageLinkModal"
        >
          <span class="add-new-menu__item-text"
            >{{ $t("common.link")
            }}<v-icon color="secondary" size="20">mdi-link</v-icon></span
          >
        </v-list-item>
      </v-list>
    </v-menu>
    <CommonDialog
      v-if="isLinkModalOpen || linkModalOpen"
      :isDialogOpened="isLinkModalOpen || linkModalOpen"
      width="500"
      @handleCloseDialog="closeDialog()"
    >
      <UploadLinkModal :closeModal="() => (isLinkModalOpen = false)" />
    </CommonDialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { ModuleTypes } from "@/store/ModuleTypes";
import { CommonDialogTypes } from "@/views/academy/enums/CommonDialogTypes";
import UploadLinkModal from "@/views/academy/storage/UploadLinkModal";
import CommonDialog from "@/views/academy/common/dialog/CommonDialog";
import { bus } from "@/main";

export default {
  name: "AddStorageItemMenu",
  components: {
    UploadLinkModal,
    CommonDialog
  },
  props: {
    isMenuDisabled: {
      type: Boolean,
      default: false
    },
    limitedFunctionality: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    DEFAULT: CommonDialogTypes.DEFAULT,
    FULLSCREEN: CommonDialogTypes.FULLSCREEN,
    isLinkModalOpen: false
  }),
  computed: {
    ...mapGetters(ModuleTypes.STORAGE, [
      "isAddFolderDialogOpened",
      "isFormDialogOpened",
      "isTodoDialogOpened",
      "linkModalOpen"
    ])
  },
  methods: {
    ...mapMutations(ModuleTypes.STORAGE, [
      "toggleAddFolderDialog",
      "toggleFormDialog",
      "toggleTodoDialog",
      "toggleStorageLinkModal"
    ]),
    closeDialog() {
      this.isLinkModalOpen = false;
      this.toggleStorageLinkModal({ linkModalOpen: false });
    },
    showAddFolderDialog() {
      if (this.limitedFunctionality) {
        bus.$emit("showExpiredSubscription");
      } else {
        this.toggleAddFolderDialog({ isAddFolderDialogOpened: true });
      }
    },
    showFormDialog() {
      if (this.limitedFunctionality) {
        bus.$emit("showExpiredSubscription");
      } else {
        this.toggleFormDialog({
          isFormDialogOpened: true,
          isFormCreateDialog: true
        });
      }
    },
    showTodoDialog() {
      if (this.limitedFunctionality) {
        bus.$emit("showExpiredSubscription");
      } else {
        this.toggleTodoDialog({
          isTodoDialogOpened: true,
          isTodoCreateDialog: true
        });
      }
    },
    showStorageLinkModal() {
      if (this.limitedFunctionality) {
        bus.$emit("showExpiredSubscription");
      } else {
        this.isLinkModalOpen = true;
      }
    }
  }
};
</script>

<style scoped>
.add_storage_item_button {
  text-transform: capitalize;
}

.add-new-menu__item-text {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.v-menu__content {
  margin-top: 2px;
  border-radius: 10px;
}
</style>
